import { Box, styled } from "@mui/material";

export const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "drawerWidthValue",
})<{
  open?: boolean;
  drawerWidthValue: string;
}>(({ theme, open, drawerWidthValue }) => ({
  flexGrow: 1,
  // padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidthValue}`,
  overflowX: "hidden", // Ensure that any overflow in horizontal content is hidden
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export const StyledBox = styled(Box)({
  display: "flex",
  width: "100vw",
  overflowX: "hidden",
});

export const StyledTopMenuSectionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-between",
});
